module.exports = __webpack_public_path__ + "media/images/insights_report_background-8379725594d9e2aa7f17c9419253b2ba.png";